import { equals, makeFilter, orderBy, select } from 'utils/dynamic';
import { API, apiRtk, rtkAdapterDynamicToSource, RTK_TAGS } from 'utils/service';
import { ICasePageType } from '__generated__/api';
import { AxiosResponse } from 'axios';

export enum CASE_PAGE_TYPE {
  RedFlag = 1,
  DosageForm,
  Symptom,
  Sensitivity,
  Message,
  MedicalCondition,
  Decision,
  Start,
  Stop,
  End,
  ComputeMedicalCondition,
  MedicalConditionGroup,
  DietaryPreference,
}
export interface IAppCasePageType extends Omit<ICasePageType, 'cpType'> {
  cpType: CASE_PAGE_TYPE;
}

type SourceCasePageType = Pick<IAppCasePageType, 'id' | 'isActive' | 'title' | 'cpType'>;

export const apiCasePageTypes = apiRtk.injectEndpoints({
  endpoints: (build) => ({
    getSourceCasePageTypes: build.query<Array<SourceCasePageType>, void>({
      queryFn: async () => {
        try {
          const res = await API.api.casePageTypesGetAllDynamicCreate({
            select: select('id', 'title', 'cpType', 'isActive'),
            filter: makeFilter('isActive', true, equals),
            orderBy: orderBy('title', 'asc'),
          });

          return rtkAdapterDynamicToSource(res) as unknown as AxiosResponse<Array<SourceCasePageType>>;
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [{ type: RTK_TAGS.CASES_PAGE_TYPES }],
    }),
  }),
});
